const STORAGE_PREFIX = "hbh-employee.help";

/**
 * Whether the guide also shows a floating "?" over the page.
 *
 * Off by default: the bottom-right corner is where the chat toggle and the right-hand column of
 * the pages live. The docked "?" in the top bar is always reachable and covers nothing, so the
 * floating one is a preference for people who want the guide under the cursor.
 *
 * localStorage rather than a jotai atom on purpose: this is one component's own chrome, not app
 * state, and `help/` stays importable with no providers around it.
 *
 * There is no language preference: the guide follows the app's language switch (see
 * `helpLanguageFor` in types.ts).
 */
export const HELP_FLOATING_KEY = `${STORAGE_PREFIX}.floating-button`;

export const readFloatingPref = (): boolean => {
  try {
    return window.localStorage.getItem(HELP_FLOATING_KEY) === "on";
  } catch {
    // Storage can throw outright (private mode, blocked site data) — fall back to the default.
    return false;
  }
};

export const writeFloatingPref = (on: boolean): void => {
  try {
    window.localStorage.setItem(HELP_FLOATING_KEY, on ? "on" : "off");
  } catch {
    // Best-effort: the choice then simply lasts for this session.
  }
};
